import axios from 'src/app-axios';
import Constants from 'src/constants';
import moment from 'moment';

export const swiftuser = {
  namespaced: true,
  state: {
    visitPurpose: null,
    qrCodeDetails: null,
    locationName: {},
    allJobs: [],
    selectedJobDetails: {},
    checkInId: {},
    jobStatus: {},
    activeCheckInDetails: {},
    visitStatus: {},
    WorkTimerLastUpdatedAt: '',
    contractorDocVerificationStatus: {},
    uploadedDocs: [],
    manualCheckoutReason: null,
    checkoutType: 'qrScan',
  },
  getters: {
    getVisitPurpose (state) {
      return state.visitPurpose;
    },
    getQrCodeDetails (state) {
      return state.qrCodeDetails;
    },
    getLocationName (state) {
      return state.locationName;
    },
    getAllJobs (state) {
      return state.allJobs;
    },
    getSelectedJobDetails (state) {
      return state.selectedJobDetails;
    },
    getCheckInId (state) {
      return state.checkInId;
    },
    getJobStatus (state) {
      return state.jobStatus;
    },
    getActiveCheckInDetails (state) {
      return state.activeCheckInDetails;
    },
    getVisitStatus (state) {
      return state.visitStatus;
    },
    getWorkTimerUpdatedAt (state) {
      return state.WorkTimerLastUpdatedAt;
    },
    getContractorDocVerifyStatus (state) {
      return state.contractorDocVerificationStatus;
    },
    getUploadedDocs (state) {
      return state.uploadedDocs;
    },
    getManualCheckoutReason (state) {
      return state.manualCheckoutReason;
    },
    getCheckoutType (state) {
      return state.checkoutType;
    },
  },
  actions: {
    async verifyLocation ({ dispatch, commit }, payload) {
      const url = 'api/devices/check-in/site-verify';
      try {
        const response = await axios.post(url, payload);
        commit('setLocationName', response.data);
      } catch (exception) {
        dispatch('alert/onAlert', {
          message: 'Something went wrong in verifying your location.',
          type: Constants.ALERT_TYPE_ERROR,
        }, { root: true });
        throw exception;
      }
    },
    async verifyDocuments ({ dispatch, commit }, payload) {
      const url = `api/devices/check-in/documents/verify/${payload.type}`;
      try {
        const status = await axios.post(url);
        commit('setContractorDocVerifyStatus', status.data);
      } catch (exception) {
        dispatch('alert/onAlert', {
          message: 'Something went wrong in verifying your documents.',
          type: Constants.ALERT_TYPE_ERROR,
        }, { root: true });
        throw exception;
      }
    },
    async checkInUser ({ dispatch, commit }, payload) {
      const url = 'api/devices/service-providers/checkin';
      try {
        const response = await axios.post(url, payload);
        commit('setCheckInId', response.data);
      } catch (exception) {
        dispatch('alert/onAlert', {
          message: 'Something went wrong in check-in you to this location.',
          type: Constants.ALERT_TYPE_ERROR,
        }, { root: true });
        throw exception;
      }
    },
    saveVisitPurpose (context, details) {
      context.commit('setVisitPurpose', details);
    },
    onQrCodeScan (context, details) {
      context.commit('setQrCodeDetails', details);
    },
    async fetchAllJobs ({ dispatch, commit }, { params }) {
      const url = 'api/devices/job-details';
      try {
        const jobs = await axios.get(url, { params: params });
        commit('setAllJobs', jobs.data);
      } catch (exception) {
        dispatch('alert/onAlert', {
          message: 'Something went wrong in getting the jobs list.',
          type: Constants.ALERT_TYPE_ERROR,
        }, { root: true });
      }
    },
    saveSelectedJobDetails (context, details) {
      context.commit('setSelectedJobDetails', details);
    },
    async sendJobDetails ({ dispatch }, payload) {
      const url = 'api/devices/check-in/job';
      try {
        await axios.post(url, payload);
      } catch (exception) {
        dispatch('alert/onAlert', {
          message: 'Something went wrong in sending your your job details.',
          type: Constants.ALERT_TYPE_ERROR,
        }, { root: true });
        throw exception;
      }
    },
    async sendVisitDetails ({ dispatch }, payload) {
      const url = `api/devices/check-in/${payload.checkInId}/visitor`;
      try {
        await axios.post(url, payload.purpose);
      } catch (exception) {
        dispatch('alert/onAlert', {
          message: 'Something went wrong in sending your your visit purpose details.',
          type: Constants.ALERT_TYPE_ERROR,
        }, { root: true });
        throw exception;
      }
    },
     saveJobStatus (context, details) {
      context.commit('setJobStatus', details);
    },
    async fetchActiveCheckInDetails ({ dispatch, commit, state }, payload) {
      if (Object.keys(state.activeCheckInDetails).length > 0) {
        return;
      }
      const url = `api/devices/check-in/${payload.checkInId}`;
      try {
        const details = await axios.get(url);
        commit('setActiveCheckInDetails', details.data);
      } catch (exception) {
        dispatch('alert/onAlert', {
          message: 'Something went wrong in getting the active check-in details.',
          type: Constants.ALERT_TYPE_ERROR,
        }, { root: true });
      }
    },
    async checkOutUser ({ dispatch }, payload) {
      const url = `api/devices/check-out/${payload.checkInId}`;
      try {
        await axios.post(url, payload.checkOutTime);
      } catch (exception) {
        dispatch('alert/onAlert', {
          message: 'Something went wrong in check-out you from this location.',
          type: Constants.ALERT_TYPE_ERROR,
        }, { root: true });
        throw exception;
      }
    },
    async sendJobStatus ({ dispatch }, payload) {
      const url = `api/devices/check-out/${payload.checkInId}/contractor`;
      try {
        await axios.post(url, payload.statusDetails);
      } catch (exception) {
        dispatch('alert/onAlert', {
          message: 'Something went wrong in sending your job status.',
          type: Constants.ALERT_TYPE_ERROR,
        }, { root: true });
        throw exception;
      }
    },
    saveVisitStatus (context, details) {
      context.commit('setVisitStatus', details);
    },
    async sendVisitStatus ({ dispatch }, payload) {
      const url = `api/devices/check-out/${payload.checkInId}/visitor`;
      try {
        await axios.post(url, payload.statusDetails);
      } catch (exception) {
        dispatch('alert/onAlert', {
          message: 'Something went wrong in sending your job status.',
          type: Constants.ALERT_TYPE_ERROR,
        }, { root: true });
        throw exception;
      }
    },
    updateWorkTimer ({ commit }) {
      commit('setWorkTimerUpdatedAt', moment().toISOString());
    },
    clearContractorDocVerifyStatus (context) {
      context.commit('removeContractorDocVerifyStatus');
    },
    async fetchUploadedDocs ({ dispatch, commit }) {
      const url = 'api/devices/documents';
      try {
        const docs = await axios.get(url);
        commit('setUploadedDocs', docs.data);
      } catch (exception) {
        dispatch('alert/onAlert', {
          message: 'Something went wrong in fetching your uploaded documents list.',
          type: Constants.ALERT_TYPE_ERROR,
        }, { root: true });
      }
    },
    clearScannedLocationName (context) {
      context.commit('removeScannedLocationName');
    },
    saveManualCheckoutReason (context, reason) {
      context.commit('setManualCheckoutReason', reason);
    },
    saveCheckoutType (context, type) {
      context.commit('setCheckoutType', type);
    },
    clearManualCheckoutReason (context) {
      context.commit('removeManualCheckoutReason');
    },
    async fetchUsersCurrentCheckInDetails ({ dispatch, commit, state }) {
      const url = 'api/devices/service-providers/user-active-records';
      try {
        const details = await axios.get(url);
        commit('setActiveCheckInDetails', details.data);
      } catch (exception) {
        dispatch('alert/onAlert', {
          message: 'Something went wrong in getting the active check-in details.',
          type: Constants.ALERT_TYPE_ERROR,
        }, { root: true });
      }
    },
  },
  mutations: {
    setVisitPurpose (state, data) {
      state.visitPurpose = data;
    },
    setQrCodeDetails (state, data) {
      state.qrCodeDetails = data;
    },
    setLocationName (state, name) {
      state.locationName = name;
    },
    setAllJobs (state, data) {
      state.allJobs = data;
    },
    setSelectedJobDetails (state, data) {
      state.selectedJobDetails = data;
    },
    setCheckInId (state, details) {
      state.checkInId = details;
    },
    setJobStatus (state, data) {
      state.jobStatus = data;
    },
    setActiveCheckInDetails (state, data) {
      state.activeCheckInDetails = data;
    },
    setVisitStatus (state, data) {
      state.visitStatus = data;
    },
    setWorkTimerUpdatedAt (state, dateTime) {
      state.WorkTimerLastUpdatedAt = dateTime;
    },
    setContractorDocVerifyStatus (state, status) {
      state.contractorDocVerificationStatus = status;
    },
    removeContractorDocVerifyStatus (state) {
      state.contractorDocVerificationStatus = {};
    },
    setUploadedDocs (state, docs) {
      state.uploadedDocs = docs;
    },
    removeScannedLocationName (state) {
      state.locationName = {};
    },
    setManualCheckoutReason (state, reason) {
      state.manualCheckoutReason = reason;
    },
    setCheckoutType (state, type) {
      state.checkoutType = type;
    },
    removeManualCheckoutReason (state) {
      state.manualCheckoutReason = null;
    },
  },
};
